<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>
          {{ $tc("luxriot.master_account", 1) }}
        </label>
        <v-select
          label="title"
          :placeholder="$tc('luxriot.placeholderMasterAccount', 2)"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="masterAccounts"
          :reduce="({ id }) => id"
          @input="(val) => $emit('master-account-selected', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import axios from "@/libs/axios";
import { onMounted, ref } from "@vue/composition-api";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  setup(_, { emit }) {
    onMounted(async () => {
      let requestMasterAccounts = { isList: true };

      let { data } = await axios.get("/v1/services/luxriot/master-accounts", {
        params: requestMasterAccounts,
      });

      let { data: dataApi, success } = data;

      if (!success) {
        masterAccounts.value = [];
      }

      masterAccounts.value = dataApi;
    });

    //Data
    const masterAccounts = ref([]);

    return {
      masterAccounts,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
